function oRenderEngine(engine) {
  this.engine = engine;
}

oRenderEngine.prototype = {
  init: function () {
    this.engine.tips.debug("[RenderEngine] " + this.engine.router.get().path);
    // 渲染模板
    this.engine.template.render();
  }
}

export {
  oRenderEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/render.js